import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { DocumentoObras } from '../../models/documento-obras.model';
import { DocumentoObrasService } from '../../services/documento-obras.services';

@Component({
  selector: 'app-documento-obras-list',
  templateUrl: './documento-obras-list.component.html',
  styleUrls: ['./documento-obras-list.component.scss']
})
export class DocumentoObrasListComponent extends BaseListComponent<DocumentoObras> implements OnInit, OnDestroy {

  @Input() idObra: number;
  documentoList: DocumentoObras[];
  permission: any;

  constructor(
    private myService: DocumentoObrasService,
  ) {
    super();
  }

  ngOnInit() {
    this.initList();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    if (this.idObra) {
      this.addSub(
        this.myService.getListAll(this.idObra).subscribe((res) => {
          this.documentoList = res['list'];
          this.permission = res['permission'];
          this.loaded();
        })
      );
    }
  }

  typeQueryParams() {
    return { work_id: this.idObra };
  }

  novo() {
    return ['/qrobras', 'documento', 'adicionar'];
  }

  confirmExcluir(data: any) {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(data);
      }
    });
  }

  excluir(data: any): void {
    this.loading();
    this.myService.delete(data.id).subscribe({
      next: (res) => {
        this.initList();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
      }
    });
  }

  editar(data: any) {
    return ['/qrobras', 'documento', data.id];
  }

  download(data) {
    this.loading();
    this.addSub(
      this.myService.download(data.id).subscribe({
        next: (res) => {
          const contentDispositionHeader = res.headers.get('content-disposition');
          const fileName = contentDispositionHeader ? this.myService.extractFilename(contentDispositionHeader) : data?.name;
          const blob = new Blob([res.body], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url);
          this.loaded();
        },
        error: (error) => {
          let msg;
          if (error?.status == 404) {
            msg = "Arquivo não encontrado.";
          }
          this.msgError(msg ? msg : error?.error?.message);
          this.loaded();
        },
      })
    );
  }
}

